import { Box, Grid, CircularProgress } from "@mui/material";
import PlanAPI, { PlanCreateSessionResponse } from "apis/PlanAPI";
import { FC, Fragment, useEffect, useState } from "react";
import DashboardNavbar from "./../../components/Layouts/DashboardNavbar";
import useTitle from "hooks/useTitle";
import { useTranslation } from "react-i18next";
import { Wrapper, PlanWrapper, LoadingContainer } from "./Plan.styles";

// Global declaration for Stripe Pricing Table
declare global {
  namespace JSX {
    interface IntrinsicElements {
      "stripe-pricing-table": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

const Plan: FC = () => {
  const { t } = useTranslation();
  useTitle(t("Planos"));

  const [planSession, setPlanSession] = useState<string | undefined>(undefined);
  const [planEnvironment, setPlanEnvironment] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    PlanAPI.createSession().then((response) => {
      const result = response.data as PlanCreateSessionResponse;
      setPlanSession(result.session);
      setPlanEnvironment(result.environment);
    });
  }, []);

  return (
    <PlanWrapper>
      <DashboardNavbar setShowMobileSideBar={() => {}} hideSidebar={false} />
      <Grid spacing={4}>
        <Box flexGrow={1} textAlign="center">
          <img
            src="/static/logo/logo.svg"
            width="100%"
            height="50"
            alt="Logo"
          />
        </Box>
        <Fragment>
          <script
            async
            src="https://js.stripe.com/v3/pricing-table.js"
          ></script>
          <Wrapper>
            {planSession && planEnvironment ? (
              <>
                {planEnvironment === "PRODUCTION" ? (
                  <stripe-pricing-table
                    pricing-table-id="prctbl_1PyMy5RrePlfL0B4AIMf1rOn"
                    publishable-key="pk_live_51Pi0vtRrePlfL0B4qqeIHBakLjxQL1zg5sEMyEbhJ9FYpTuRApQiSufXSNVL6gNrYJ01kMBVArrgkDwBO4atskWl0078zyaAb4"
                    customer-session-client-secret={planSession}
                  />
                ) : (
                  <stripe-pricing-table
                    pricing-table-id="prctbl_1Pi1bHRrePlfL0B4zcCwdcaW"
                    publishable-key="pk_test_51Pi0vtRrePlfL0B4cZBMleQzWLdeKyP1AnLWKLoSip0FtQ5FwtxYmdp2delzVyoQfUGg6r78OvTaezGGloEV62ZD00USawLrGl"
                    customer-session-client-secret={planSession}
                  />
                )}
              </>
            ) : (
              <LoadingContainer>
                <CircularProgress />
              </LoadingContainer>
            )}
          </Wrapper>
        </Fragment>
      </Grid>
    </PlanWrapper>
  );
};

export default Plan;
